import { defineMessages } from 'react-intl';

export default defineMessages({
    removeDocument: {
        id: 'policy.common.component.documents.Remove Document',
        defaultMessage: 'Remove Document'
    },
    confirmRemoveDocument: {
        id: 'policy.common.component.documents.Are you sure you want to remove',
        defaultMessage: 'Are you sure you want to remove'
    },
    documentRemoveConfirmYes: {
        id: 'policy.common.component.documents.Yes',
        defaultMessage: 'Yes'
    },
    documentRemoveConfirmNo: {
        id: 'policy.common.component.documents.No',
        defaultMessage: 'No'
    },
    documentDeletionFailed: {
        id: 'policy.common.component.documents.Document deletion failed',
        defaultMessage: 'Document deletion failed'
    },
    documentCannotDeleted: {
        id: 'policy.common.component.documents.Sorry your document could not be deleted at this time',
        defaultMessage: 'Sorry your document could not be deleted at this time'
    },
    documentDateUploaded: {
        id: 'policy.common.component.documents.Date Uploaded',
        defaultMessage: 'Date Uploaded'
    },
    documentUploadFailed: {
        id: 'policy.common.component.documents.Document upload failed',
        defaultMessage: 'Document upload failed'
    },
    documentCannotUploaded: {
        id: 'policy.common.component.documents.Failed to upload file, either you do not have permission or a file exists with the same name.',
        defaultMessage: 'Failed to upload file, either you do not have permission or a file exists with the same name.'
    },
    noDocumentFound: {
        id: 'policy.common.component.documents.No Documents Found.',
        defaultMessage: 'No Documents Found.'
    },
    documentUploadedTitle: {
        id: 'policy.common.component.documents.Document uploaded successfully',
        defaultMessage: 'Document uploaded successfully'
    },
    documentUploaded: {
        id: 'policy.common.component.documents.Your Document has been uploaded successfully and is under review. Please keep a copy of your uploaded document for your records.',
        defaultMessage: 'Your Document has been uploaded successfully and is under review. Please keep a copy of your uploaded document for your records.'
    },
    viewDownload: {
        id: 'tdic.policy.common.component.documents.billing-documents.View/Download',
        defaultMessage: 'View/Download'
    },
    downloadErrorMessage: {
        id: 'tdic.policy.common.component.documents.billing-documents.Apologies: we are unable to access your billing documents at this time. Please try again later.',
        defaultMessage: 'Apologies: we are unable to access your billing documents at this time. Please try again later.'
    },
    uploadDocumentInfo: {
        id: 'tdic.policy.common.component.documents.Please select a single document file from your device to upload.',
        defaultMessage: 'Please select a single document file from your device to upload.'
    },
    reviewDocumentMessage: {
        id: 'tdic.policy.common.component.documents.Your uploaded document will be reviewed by your agent team member and they will contact you if necessary.',
        defaultMessage: 'Your uploaded document will be reviewed by your agent team member and they will contact you if necessary.'
    },
    policyDocumentMessage: {
        id: 'tdic.policy.common.component.documents.The following documents were generated by TDIC for you to download, save and print at your convenience on desktop, laptop and tablet devices. Contact your agent if you have any questions or don\'t see what you are looking for.',
        defaultMessage: 'The following documents were generated by TDIC for you to download, save and print at your convenience on desktop, laptop and tablet devices. Contact your agent if you have any questions or don\'t see what you are looking for.'
    }
});
